import { ModalResultType } from '@/helper/Types'

export default class ModalResult<T> {
  constructor(
    public readonly resultType: ModalResultType,
    public readonly payload: T,
    public readonly params?: unknown
  ) {
  }
}
